import React from "react";
import ReactModal from "react-modal";
import { CButton } from "@coreui/react";
import "./mainModal.scss";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";

export const MainModal = ({
  isOpen,
  onClose,
  parentSelector = ".notifications",
  headerText,
  headerCloseHandler,
  containerClassName = "",
  children,
  primaryButtonText,
  primaryButtonClass,
  primaryButtonColor,
  primaryButtonDisabled,
  primaryBtnHandler,
  secondaryBtnText,
  secondaryBtnClass,
  secondaryBtnHandler,
  isFixedFooter,
  isFixedHeader,
  isFixedBody,
  width = 800,
  height = 540,
  swapFooter,
  isLoading = false,
  loadingClass = "",
  customStyles = {},
  renderFooter,
  isAdminPanel = true
}) => {
  const cName = containerClassName + (isAdminPanel ? "" : " popup__container--dashboard");
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      parentSelector={() => document.querySelector(parentSelector)}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      portalClassName="popup"
      className={`popup__container ${cName}`}
      overlayClassName="popup__overlay"
      style={{
        content: {
          width,
          height,
          ...customStyles
        }
      }}
    >
      {isLoading ? (
        <LoadingAnimation height={height} customStyle={loadingClass} />
      ) : (
        <div>
          {swapFooter ? (
            <Footer
              renderFooter={renderFooter}
              isFixedFooter={isFixedFooter}
              primaryButtonText={primaryButtonText}
              primaryButtonClass={primaryButtonClass}
              primaryButtonColor={primaryButtonColor}
              primaryButtonDisabled={primaryButtonDisabled}
              primaryBtnHandler={primaryBtnHandler}
              secondaryBtnText={secondaryBtnText}
              secondaryBtnClass={secondaryBtnClass}
              secondaryBtnHandler={secondaryBtnHandler}
              isAdminPanel={isAdminPanel}
            />
          ) : (
            <Header
              header={headerText}
              headerCloseHandler={headerCloseHandler}
              isFixedHeader={isFixedHeader}
            />
          )}

          <Body content={children} isFixedBody={isFixedBody} />
          {!swapFooter && (
            <Footer
              renderFooter={renderFooter}
              isFixedFooter={isFixedFooter}
              primaryButtonText={primaryButtonText}
              primaryButtonClass={primaryButtonClass}
              primaryButtonColor={primaryButtonColor}
              primaryButtonDisabled={primaryButtonDisabled}
              primaryBtnHandler={primaryBtnHandler}
              secondaryBtnText={secondaryBtnText}
              secondaryBtnClass={secondaryBtnClass}
              secondaryBtnHandler={secondaryBtnHandler}
              isAdminPanel={isAdminPanel}
            />
          )}
        </div>
      )}
    </ReactModal>
  );
};

const Header = ({ header, headerCloseHandler, isFixedHeader }) => {
  if (!header) return null;
  return (
    <div
      className={isFixedHeader ? "popup__header fixedHeader" : "popup__header"}
      data-testid="popup-header"
    >
      <h4>{header}</h4>
      <div className="popup__header__close" role="button" onClick={(e) => headerCloseHandler(e)}>
        x
      </div>
    </div>
  );
};

const Body = ({ content, isFixedBody }) => {
  return (
    <div data-testid="popup-body" className={isFixedBody ? "popup__body fixedBody" : "popup__body"}>
      {content}
    </div>
  );
};

const Footer = ({
  isFixedFooter,
  primaryButtonText,
  primaryButtonClass,
  primaryButtonColor = "primary",
  primaryButtonDisabled,
  primaryBtnHandler,
  secondaryBtnText,
  secondaryBtnClass = "secondary-btn",
  secondaryBtnHandler,
  renderFooter,
  isAdminPanel
}) => {
  return (
    <div
      className={isFixedFooter ? "fixedFooter popup__footer" : "popup__footer"}
      data-testid="popup-footer"
    >
      {renderFooter ? (
        renderFooter()
      ) : isAdminPanel ? (
        <>
          <CButton
            color={primaryButtonColor}
            disabled={primaryButtonDisabled}
            className={primaryButtonClass}
            onClick={() => primaryBtnHandler()}
          >
            {primaryButtonText}
          </CButton>
          {secondaryBtnText && (
            <CButton
              color="secondary"
              className={secondaryBtnClass}
              onClick={() => secondaryBtnHandler()}
            >
              {secondaryBtnText}
            </CButton>
          )}
        </>
      ) : (
        <>
          {secondaryBtnText && (
            <button className={`button button--${secondaryBtnClass}`} onClick={secondaryBtnHandler}>
              {secondaryBtnText}
            </button>
          )}

          {primaryButtonText && (
            <button
              className={`button button--${primaryButtonClass}`}
              onClick={primaryBtnHandler}
              disabled={primaryButtonDisabled}
            >
              {primaryButtonText}
            </button>
          )}
        </>
      )}
    </div>
  );
};
